import Api from './Api';

const NavigationService = {};

const cardsApiUrl = '/docs/meta/cards';
const glossaryUrl = '/docs/meta/glossary';
const quickstartsApiUrl = '/docs/meta/quickstart';
const quickstartsApiUrlWithLocale = '/docs/{{locale}}/meta/quickstart';

NavigationService.loadCards = () => Api.get(cardsApiUrl);

NavigationService.loadGlossary = () => Api.get(glossaryUrl);

NavigationService.loadQuickstarts = (payload) =>
  Api.get(
    payload?.locale && payload.locale !== 'en-us'
      ? quickstartsApiUrlWithLocale.replace('{{locale}}', payload?.locale)
      : quickstartsApiUrl
  ).then((result) => ({ quickstarts: result, locale: payload?.locale }));

export default NavigationService;
